export const useClsUtil_01 = () => {
  const getCls01 = ({ isWarning }: any) => {
    const baseCls = "rounded-10";
    let classString = "";
    classString = `bg-[var(--app-bg-08)] p-16 backdrop-blur-10 ${baseCls}`;
    // 添加警告边框样式
    if (isWarning) {
      classString += " border-l-3 border-l-solid border-l-[var(--app-border-09)]";
    }
    return classString;
  };

  return { getCls01 };
};
